import React from "react";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import { RadioButton, Image } from "hesus-ui-kit";
import { renderPriceWithCurrency, addSpace } from "@utils/utils";
import { ColumnButton } from "@utils/extra-style";
import treatmentIcon from "@icons/ic-treatment.svg";
import transportIcon from "@icons/ic-transport-only.svg";
import treatmentTransportIcon from "@icons/ic-transport-treatment.svg";
import transportDisabledIcon from "@icons/ic-transport-disabled.svg";
import treatmentDisabledIcon from "@icons/ic-treatment-disabled.svg";
import transportTreatmentDisabledIcon from "@icons/ic-transport- treatment-disabled.svg";

import { GridRow } from "../../AddEditSupplier.styled";
import {
  ProductContainer,
  RadioItem,
  SolutionOuter,
  GridSubItem,
} from "./SupplierItems.styled";
import "../../AddEditSupplier.scss";

const PlanningSolution = (props) => {
  const { t, item, koMarginRate, onChange, itemIndex } = props;

  return (
    <GridRow column="1fr" gap="10px" padding="10px">
      <SolutionOuter>
        {item?.itemInfo?.solutions?.map((solution, solutionIndex) => {
          return (
            <ProductContainer
              key={
                "supplier-planning-serviceitems-solution-" +
                solution?.id +
                "-" +
                solutionIndex
              }
              opacity={solution?.isDisabled ? "0.7" : "1"}
            >
              <GridRow column="3% 58% 23% 13%" gap="1%">
                <RadioItem
                  className={
                    solution?.isDisabled
                      ? "add-edit-supplier-planning__radioborder"
                      : ""
                  }
                >
                  <RadioButton
                    value={item?.solutionId?.value}
                    onChange={(e) => {
                      onChange(
                        e,
                        itemIndex,
                        "solution",
                        solution?.transportPrice?.transportType?.id,
                        solution?.id
                      );
                    }}
                    name={item.solutionId.name}
                    options={[
                      {
                        label: "",
                        value: solution?.solutionId,
                      },
                    ]}
                    disabled={solution?.isDisabled}
                  />
                </RadioItem>
                <GridRow column="1fr" gap="0px">
                  <GridSubItem
                    fontWeight="700"
                    fontSize="16px"
                    padding="0px"
                    color={solution?.isDisabled ? "#474747" : "#0a4986"}
                  >
                    {solution?.centre?.supplierName}
                    {" - "}
                    {solution?.centre?.name}
                  </GridSubItem>
                  <GridSubItem
                    fontWeight="400"
                    fontSize="14px"
                    color="#474747"
                    fontStyle="italic"
                    padding="0px"
                  >
                    {solution?.product?.name}
                  </GridSubItem>
                </GridRow>
                <GridRow column="1fr" gap="0px" padding="0px 0px 0px 13px">
                  {[1, 4].indexOf(parseInt(solution.priceType, 10)) !== -1 && (
                    <GridSubItem
                      fontWeight="400"
                      fontSize="14px"
                      color="#474747"
                      padding="0px 0px 2px 0px"
                    >
                      <Image
                        src={
                          solution?.isDisabled
                            ? treatmentDisabledIcon
                            : treatmentIcon
                        }
                        alt={t("TREATMENT_ONLY")}
                        title={t("TREATMENT_ONLY")}
                        className="add-edit-supplier-list__planning-solution-icon"
                      />
                      {solution?.treatmentPrice?.name}
                      {renderPriceWithCurrency(
                        addSpace(solution?.treatmentPrice?.price),
                        t(solution?.treatmentPrice?.unit),
                        solution?.treatmentPrice?.currency?.symbol,
                        solution?.treatmentPrice?.currency?.position
                      )}
                    </GridSubItem>
                  )}
                  {[1, 3].indexOf(parseInt(solution.priceType, 10)) !== -1 && (
                    <GridSubItem
                      fontWeight="400"
                      fontSize="14px"
                      color="#474747"
                      fontStyle="normal"
                      padding="0px"
                    >
                      <Image
                        src={
                          solution?.isDisabled
                            ? transportDisabledIcon
                            : transportIcon
                        }
                        alt={t("TRANSPORT_ONLY")}
                        title={t("TRANSPORT_ONLY")}
                        className="add-edit-supplier-list__planning-solution-icon"
                      />
                      {renderPriceWithCurrency(
                        addSpace(solution?.transportPrice?.price),
                        t(solution?.transportPrice?.unit),
                        solution?.transportPrice?.currency?.symbol,
                        solution?.transportPrice?.currency?.position
                      )}
                    </GridSubItem>
                  )}
                  {parseInt(solution.priceType, 10) === 2 && (
                    <GridSubItem
                      fontWeight="400"
                      fontSize="14px"
                      color="#474747"
                      fontStyle="normal"
                      padding="0px"
                    >
                      <Image
                        src={
                          solution?.isDisabled
                            ? transportTreatmentDisabledIcon
                            : treatmentTransportIcon
                        }
                        alt={t("TREATMENT_TRANSPORT_PRICE")}
                        title={t("TREATMENT_TRANSPORT_PRICE")}
                        className="add-edit-supplier-list__planning-transport-icon"
                      />
                      {renderPriceWithCurrency(
                        addSpace(solution?.transportPrice?.price),
                        t(solution?.transportPrice?.unit),
                        solution?.transportPrice?.currency?.symbol,
                        solution?.transportPrice?.currency?.position
                      )}
                    </GridSubItem>
                  )}
                </GridRow>
                <GridRow column="1fr" gap="0px">
                  <GridSubItem
                    fontWeight="700"
                    fontSize="14px"
                    color="#474747"
                    padding="0px"
                    style={{ justifySelf: "center" }}
                  >
                    {solution?.marginRate !== "" &&
                      solution?.marginRate !== null && (
                        <ColumnButton
                          border={
                            solution?.isDisabled
                              ? "#767676"
                              : solution?.marginRate >= koMarginRate
                              ? "#3ebbb9"
                              : "#f08046"
                          }
                          background={
                            solution?.isDisabled
                              ? "#767676"
                              : solution?.marginRate >= koMarginRate
                              ? "#3ebbb9"
                              : "#f08046"
                          }
                          padding="10px"
                          style={{ borderRadius: "20px", minWidth: "4rem" }}
                        >
                          {solution?.marginRate + " %"}
                        </ColumnButton>
                      )}
                  </GridSubItem>
                </GridRow>
              </GridRow>
            </ProductContainer>
          );
        })}
      </SolutionOuter>
    </GridRow>
  );
};

PlanningSolution.propTypes = {
  t: PropTypes.func.isRequired,
  isEdit: PropTypes.bool,
};

PlanningSolution.defaultProps = {
  isEdit: false,
};
export default withTranslation()(PlanningSolution);
